import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b5940ae8")

_pushScopeId("data-v-b5940ae8")
const _hoisted_1 = {
  key: 0,
  class: "btn-tools"
}
const _hoisted_2 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_ChatRoom = _resolveComponent("ChatRoom")
  const _component_Alert = _resolveComponent("Alert")
  const _directive_noneFooter = _resolveDirective("noneFooter")
  const _directive_simpleHeader = _resolveDirective("simpleHeader")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.isGuest)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_Button, {
            icon: "pi pi-share-alt",
            title: _ctx.t('copy share link'),
            onClick: _ctx.copyInviteLink
          }, null, 8, ["title", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.state.isLoading)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.isChat)
            ? (_openBlock(), _createBlock(_component_ChatRoom, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode("iframe", {
            src: _ctx.state.iframe.src,
            style: _ctx.state.iframe.style,
            frameborder: "0",
            allow: "display-capture;camera;microphone",
            class: "video-frame"
          }, null, 12, ["src"])
        ], 512)), [
          [_directive_noneFooter],
          [_directive_simpleHeader]
        ])
      : _createCommentVNode("", true),
    (!!_ctx.alert.content)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 2,
          alert: _ctx.alert,
          isConfirm: true,
          "onUpdate:clear": _cache[1] || (_cache[1] = 
          () => {
            _ctx.alert.content = '';
          }
        )
        }, null, 8, ["alert"]))
      : _createCommentVNode("", true)
  ], 64))
})